import React, { Component } from 'react'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react'

import ActiveBookingsRow from './ActiveBookingsRow'

import { Bookings, Heading, BookingInfo } from './ActiveBookingsStyle'
import { BlackHeading, Black, LogeButtonSlim } from '../GeneralStyle'

@inject('bookingStore')

@observer
class ActiveBookings extends Component {

  constructor(props) {
    super(props)
    this.state = {
      cancel: false,
    }
    this.openCancelModal = this.openCancelModal.bind(this)
  }

  // Check https://github.com/mobxjs/mobx-react/blob/master/README.md#faq
  // to see why I did this (componentWillMount())
  // To replicate the error that occurs otherwise put
  // this.props.bookingStore.getActiveBookings()
  // into the constructor and see what happens.

  componentWillMount() {
    this.props.bookingStore.getActiveBookings()
  }

  openCancelModal() {
    this.cancelmodal.openModal();
  }

  render() {
    const { isActiveBookings, activeBookings } = this.props.bookingStore;

    return (
      <Bookings>
        <BlackHeading style={{fontSize: "200%", margin: 25, textAlign: "left", marginBottom: 0}}>IHRE NÄCHSTEN BUCHUNGEN</BlackHeading>
        <div style={{padding: 10}}>
        {!isActiveBookings
          ? <BookingInfo style={{marginLeft: 25}}>Momentan keine Buchungen.</BookingInfo>
          : activeBookings.map((booking, key) =>
            <ActiveBookingsRow booking={booking} key={key} />
          )
        }
        </div>
      </Bookings>
    )
  }
}

ActiveBookings.propTypes = {
  bookingStore: MobxPropTypes.observableObject,
  activeBookings: MobxPropTypes.observableArray,
};

export default ActiveBookings;



// WEBPACK FOOTER //
// /src/components/internal/ActiveBookings.js